import { i18n } from '../i18n/index';
import { DialogButtonItem } from '@tencent/wphk-ui';

export type DialogBtn = DialogButtonItem;

export interface DialogOptions {
  title?: string;
  content?: string;
  htmlContent?: string;
  btns?: DialogButtonItem[];
  show?: boolean;
  align?: string;
}

export function getDefaultConfig(): DialogOptions {
  return Object.assign({}, {
    show: false,
    title: '',
    content: '',
    htmlContent: '',
    btns: [getDefaultBtn()],
    align: '',
  });
}

export function getDefaultBtn() {
  return {
    text: i18n('确定'),
  };
}
